/**
 * This is a File Service API client according to this OpenAPI spec
 * https://doxyme.gitlab.io/devops/iac-v2.0/user-guide/file-hosting/assets/openapi.yaml
 */ function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import axios from 'axios';
import { isNullish } from 'emery';
import { PrivateEphemeralConfigError } from '../errors/errors';
import { Header, Method, Mimetype } from './http';
import { Privacy } from './enums';
export var FileServiceClient = /*#__PURE__*/ function() {
    "use strict";
    function FileServiceClient(apiKey) {
        _class_call_check(this, FileServiceClient);
        _define_property(this, "apiKey", void 0);
        _define_property(this, "baseUrl", void 0);
        _define_property(this, "axios", void 0);
        var _process_env_FILE_SERVICE_API_KEY;
        this.apiKey = apiKey !== null && apiKey !== void 0 ? apiKey : String((_process_env_FILE_SERVICE_API_KEY = process.env['FILE_SERVICE_API_KEY']) !== null && _process_env_FILE_SERVICE_API_KEY !== void 0 ? _process_env_FILE_SERVICE_API_KEY : '');
        this.baseUrl = String(process.env['FILE_SERVICE_API_URL'] !== undefined ? "".concat(process.env['FILE_SERVICE_API_URL'], "/v1") : '');
        this.axios = axios;
    }
    _create_class(FileServiceClient, [
        {
            key: "headers",
            value: function headers() {
                var _obj;
                return _obj = {}, _define_property(_obj, Header.ContentType, Mimetype.Json), _define_property(_obj, Header.XApiKey, this.apiKey), _obj;
            }
        },
        {
            key: "request",
            value: function request(axiosOptions) {
                var _this = this;
                return _async_to_generator(function() {
                    return _ts_generator(this, function(_state) {
                        return [
                            2,
                            axios(_object_spread_props(_object_spread({}, axiosOptions), {
                                headers: _this.headers(),
                                baseURL: _this.baseUrl
                            }))
                        ];
                    });
                })();
            }
        },
        {
            key: "postNewFileUploadLink",
            value: /**
   Request a new file upload and receive an upload link
   */ function postNewFileUploadLink(data) {
                var _this = this;
                return _async_to_generator(function() {
                    return _ts_generator(this, function(_state) {
                        // Throw and error if no TTL specified on a private-ephemeral file
                        if (data.privacy === Privacy.PrivateEphemeral && (isNullish(data.ttl) || data.ttl < 1)) {
                            throw new PrivateEphemeralConfigError();
                        }
                        return [
                            2,
                            _this.request({
                                method: Method.Post,
                                url: 'files',
                                data: data
                            })
                        ];
                    });
                })();
            }
        },
        {
            key: "sendFile",
            value: /**
   * Given the upload link, upload a buffer or readable stream.
   */ function sendFile(url, data, mimetype, /**
     * Required for streams since axios cannot determine the length.
     */ contentLength) {
                return _async_to_generator(function() {
                    var headers;
                    return _ts_generator(this, function(_state) {
                        headers = _define_property({}, Header.ContentType, mimetype);
                        if (contentLength !== undefined) {
                            headers[Header.ContentLength] = contentLength;
                        }
                        return [
                            2,
                            axios.put(url, data, {
                                headers: headers,
                                /**
       * maxBodyLength (default: 10MB) – sets the maximum size of the request body; if exceeded, an error will be emitted.
       * @see https://github.com/follow-redirects/follow-redirects?tab=readme-ov-file#options
       *
       * We chose 500 MB as the maximum size of the request body for file uploads in February 2026.
       * @see https://gitlab.com/doxyme/code/doxyme-core/-/merge_requests/11456#note_3051089040
       */ maxBodyLength: 500 * 1024 * 1024
                            })
                        ];
                    });
                })();
            }
        },
        {
            key: "getFile",
            value: /**
   * Get metadata about a file upload
   */ function getFile(fileUuid) {
                var _this = this;
                return _async_to_generator(function() {
                    return _ts_generator(this, function(_state) {
                        return [
                            2,
                            _this.request({
                                method: Method.Get,
                                url: "files/".concat(fileUuid)
                            })
                        ];
                    });
                })();
            }
        },
        {
            key: "deleteFile",
            value: /**
   * Delete a file
   */ function deleteFile(fileUuid) {
                var _this = this;
                return _async_to_generator(function() {
                    return _ts_generator(this, function(_state) {
                        return [
                            2,
                            _this.request({
                                method: Method.Delete,
                                url: "files/".concat(fileUuid)
                            })
                        ];
                    });
                })();
            }
        }
    ]);
    return FileServiceClient;
}();
